// @ts-nocheck
// <<<<<<< HEAD
// import React from 'react'
// import { useState } from "react";
// import { Box, Button, Icon, Input, InputAdornment, TableSortLabel, Typography } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import Table from '@mui/material/Table';
// import SortArrow from '../../assets/images/sort-arrow.svg'
// import AddPlus from '../../assets/images/add-plus.svg'
// import Show from '../../assets/images/Show.svg'
// import TableBody from '@mui/material/TableBody';
// import { useTheme } from '@mui/material/styles';
// import TableCell, { tableCellClasses } from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import TablePagination from '@mui/material/TablePagination';
// import IconButton from '@mui/material/IconButton';
// import FirstPageIcon from '@mui/icons-material/FirstPage';
// import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
// import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
// import LastPageIcon from '@mui/icons-material/LastPage';
// import { Search } from "@mui/icons-material";
// import { Link } from "react-router-dom";

// function TablePaginationActions(props) {
//     const theme = useTheme();
//     const { count, page, rowsPerPage, onPageChange } = props;

//     const handleFirstPageButtonClick = (
//         event,
//     ) => {
//         onPageChange(event, 0);
//     };

//     const handleBackButtonClick = (event) => {
//         onPageChange(event, page - 1);
//     };

//     const handleNextButtonClick = (event) => {
//         onPageChange(event, page + 1);
//     };

//     const handleLastPageButtonClick = (event) => {
//         onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
//     };

//     return (
//         <Box sx={{ flexShrink: 0, ml: 2.5 }}>
//             <IconButton
//                 onClick={handleFirstPageButtonClick}
//                 disabled={page === 0}
//                 aria-label="first page"
//             >
//                 {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
//             </IconButton>
//             <IconButton
//                 onClick={handleBackButtonClick}
//                 disabled={page === 0}
//                 aria-label="previous page"
//             >
//                 {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
//             </IconButton>
//             <IconButton
//                 onClick={handleNextButtonClick}
//                 disabled={page >= Math.ceil(count / rowsPerPage) - 1}
//                 aria-label="next page"
//             >
//                 {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
//             </IconButton>
//             <IconButton
//                 onClick={handleLastPageButtonClick}
//                 disabled={page >= Math.ceil(count / rowsPerPage) - 1}
//                 aria-label="last page"
//             >
//                 {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
//             </IconButton>
//         </Box>
//     );
// }

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//     [`&.${tableCellClasses.head}`]: {
//         backgroundColor: theme.palette.common.black,
//         color: theme.palette.common.white,
//     },
//     [`&.${tableCellClasses.body}`]: {
//         fontSize: 14,
//     },
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//     '&:nth-of-type(odd)': {
//         backgroundColor: theme.palette.action.hover,
//     },
//     // hide last border
//     '&:last-child td, &:last-child th': {
//         border: 0,
//     },
// }));

// function createData(eventname, eventstart, eventsend, clientname, contactinfo, venue) {
//     return { eventname, eventstart, eventsend, clientname, contactinfo, venue }
// }

// const RowData = [
//     createData('Filled Name', 'Jan 12, 2024', 'Jan 14, 2024', 'Muhammad Asad', '+ 1 234 566 7890', 'Lorem ipsum dolor sit amet'),
//     createData('Filled Name', 'Jan 12, 2024', 'Jan 14, 2024', 'Muhammad Asad', '+ 1 234 566 7890', 'Lorem ipsum dolor sit amet'),
//     createData('Filled Name', 'Jan 12, 2024', 'Jan 14, 2024', 'Muhammad Asad', '+ 1 234 566 7890', 'Lorem ipsum dolor sit amet'),
//     createData('Filled Name', 'Jan 12, 2024', 'Jan 14, 2024', 'Muhammad Asad', '+ 1 234 566 7890', 'Lorem ipsum dolor sit amet'),
//     createData('Filled Name', 'Jan 12, 2024', 'Jan 14, 2024', 'Muhammad Asad', '+ 1 234 566 7890', 'Lorem ipsum dolor sit amet'),
//     createData('Filled Name', 'Jan 12, 2024', 'Jan 14, 2024', 'Muhammad Asad', '+ 1 234 566 7890', 'Lorem ipsum dolor sit amet'),
//     createData('Filled Name', 'Jan 12, 2024', 'Jan 14, 2024', 'Muhammad Asad', '+ 1 234 566 7890', 'Lorem ipsum dolor sit amet'),
//     createData('Filled Name', 'Jan 12, 2024', 'Jan 14, 2024', 'Muhammad Asad', '+ 1 234 566 7890', 'Lorem ipsum dolor sit amet'),
//     createData('Filled Name', 'Jan 12, 2024', 'Jan 14, 2024', 'Muhammad Asad', '+ 1 234 566 7890', 'Lorem ipsum dolor sit amet'),
//     createData('Filled Name', 'Jan 12, 2024', 'Jan 14, 2024', 'Muhammad Asad', '+ 1 234 566 7890', 'Lorem ipsum dolor sit amet'),
//     createData('Filled Name', 'Jan 12, 2024', 'Jan 14, 2024', 'Muhammad Asad', '+ 1 234 566 7890', 'Lorem ipsum dolor sit amet'),
//     createData('Filled Name', 'Jan 12, 2024', 'Jan 14, 2024', 'Muhammad Asad', '+ 1 234 566 7890', 'Lorem ipsum dolor sit amet'),
// ];

// export const EventRequest = () => {
//     const [rows, setRows] = React.useState(RowData);
//     const [page, setPage] = React.useState(0);
//     const [rowsPerPage, setRowsPerPage] = React.useState(5);
//     const [order, setOrder] = useState('asc');

//     // Avoid a layout jump when reaching the last page with empty rows.
//     const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

//     const handleChangePage = (event, newPage) => {
//         setPage(newPage)
//     }

//     const handleChangeRowsPerPage = (event) => {
//         setRowsPerPage(parseInt(event.target.value, 10));
//         setPage(0);
//     }

//     const handleSortRequest = () => {
//         const newOrder = order === 'asc' ? 'desc' : 'asc'
//         const sortedRows = [...rows].sort((a, b) => {
//             const aValue = a.name;
//             const bValue = b.name;

//             if (newOrder === 'asc') {
//                 if (aValue < bValue) {
//                     return -1;
//                 }
//                 if (aValue > bValue) {
//                     return 1;
//                 }
//                 return 0;
//             } else {
//                 if (aValue < bValue) {
//                     return 1;
//                 }
//                 if (aValue > bValue) {
//                     return -1;
//                 }
//                 return 0;
//             }
//         });
//         setRows(sortedRows);
//         setOrder(newOrder);
//     }

//     const handleSearch = (e) => {
//         const searchStr = e.target.value
//         if (!searchStr || searchStr === '') {
//             setRows(RowData)
//             return
//         }
//         let tmpRows = [...rows]
//         tmpRows = tmpRows.filter((data) => data.name.toLocaleLowerCase().includes(searchStr?.toLocaleLowerCase()))
//         setRows(tmpRows)
//     }

//     return (
//         <>
//             <Box sx={{
//                 padding: '20px 40px',
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//             }}>
//                 <Typography variant="h1">
//                     Event Requests
//                 </Typography>
//                 <Box sx={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     '& .MuiInputBase-root': {
//                         border: '1px solid #FFF !important',
//                         background: 'rgba(0, 0, 0, 0.01) !important',
//                         boxShadow: '0px 0px 30px 0px rgba(209, 117, 182, 0.20) !important',
//                         borderRadius: '8px',
//                         padding: '5px 24px 5px 16px',
//                         '&:before': {
//                             content: 'none',
//                         },
//                         '&:after': {
//                             content: 'none',
//                         },
//                         '& svg': {
//                             color: '#ffffff',
//                         },
//                         '& input': {
//                             color: '#ffffff',
//                         },
//                     }
//                 }}>
//                     <Input
//                         id="input-with-icon-adornment"
//                         onChange={handleSearch}
//                         placeholder='Search here'
//                         startAdornment={
//                             <InputAdornment position="start">
//                                 <Search />
//                             </InputAdornment>
//                         }
//                     />
//                     <Button sx={{
//                         marginLeft: '10px',
//                         borderRadius: '4px',
//                         border: '1px solid #FFF',
//                         background: 'linear-gradient(99deg, #F0F 0%, #8F00FF 100.41%) !important',
//                         boxShadow: '0px 0px 20px 0px rgba(209, 117, 182, 0.40)',
//                         minWidth: 'auto',
//                         padding: '5px !important',
//                     }}>
//                         <img src={AddPlus} />
//                     </Button>
//                 </Box>
//             </Box>
//             <Box>
//                 <TableContainer className="custom-scroll-design" sx={{ maxWidth: '100%' }}>
//                     <Table sx={{ minWidth: '1700px' }} aria-label="sticky table" stickyHeader>
//                         <TableHead>
//                             <TableRow sx={{
//                                 '& th': {
//                                     backgroundColor: '#D175B6 !important',
//                                     padding: '2px 15px',
//                                     fontSize: '20px',
//                                     color: '#ffffff',
//                                     borderColor: '#D175B6',
//                                     '& span': {
//                                         color: '#ffffff !important',
//                                     }
//                                 }
//                             }}>
//                                 <StyledTableCell>
//                                     <TableSortLabel
//                                         sx={{
//                                             padding: '2px 15px 2px 35px',
//                                         }}
//                                         active={true}
//                                         direction={order}
//                                         onClick={() => handleSortRequest()}
//                                         IconComponent={(props) => (
//                                             <IconButton {...props}>
//                                                 <Icon>{<img src={SortArrow} />}</Icon>
//                                             </IconButton>
//                                         )}
//                                     >
//                                         Event Name
//                                     </TableSortLabel>
//                                 </StyledTableCell>
//                                 <StyledTableCell>
//                                     <TableSortLabel
//                                         active={true}
//                                         direction={order}
//                                         onClick={() => handleSortRequest()}
//                                         IconComponent={(props) => (
//                                             <IconButton {...props}>
//                                                 <Icon>{<img src={SortArrow} />}</Icon>
//                                             </IconButton>
//                                         )}
//                                     >
//                                         Event Start
//                                     </TableSortLabel>
//                                 </StyledTableCell>
//                                 <StyledTableCell>
//                                     <TableSortLabel
//                                         active={true}
//                                         direction={order}
//                                         onClick={() => handleSortRequest()}
//                                         IconComponent={(props) => (
//                                             <IconButton {...props}>
//                                                 <Icon>{<img src={SortArrow} />}</Icon>
//                                             </IconButton>
//                                         )}
//                                     >
//                                         Event End
//                                     </TableSortLabel>
//                                 </StyledTableCell>
//                                 <StyledTableCell>
//                                     <TableSortLabel
//                                         active={true}
//                                         direction={order}
//                                         onClick={() => handleSortRequest()}
//                                         IconComponent={(props) => (
//                                             <IconButton {...props}>
//                                                 <Icon>{<img src={SortArrow} />}</Icon>
//                                             </IconButton>
//                                         )}
//                                     >
//                                         Client Name
//                                     </TableSortLabel>
//                                 </StyledTableCell>
//                                 <StyledTableCell>
//                                     <TableSortLabel
//                                         active={true}
//                                         direction={order}
//                                         onClick={() => handleSortRequest()}
//                                         IconComponent={(props) => (
//                                             <IconButton {...props}>
//                                                 <Icon>{<img src={SortArrow} />}</Icon>
//                                             </IconButton>
//                                         )}
//                                     >
//                                         Contact Info
//                                     </TableSortLabel>
//                                 </StyledTableCell>
//                                 <StyledTableCell>
//                                     <TableSortLabel
//                                         active={true}
//                                         direction={order}
//                                         onClick={() => handleSortRequest()}
//                                         IconComponent={(props) => (
//                                             <IconButton {...props}>
//                                                 <Icon>{<img src={SortArrow} />}</Icon>
//                                             </IconButton>
//                                         )}
//                                     >
//                                         Venue
//                                     </TableSortLabel>
//                                 </StyledTableCell>
//                             </TableRow>
//                         </TableHead>
//                         <TableBody sx={{
//                             '& td': {
//                                 borderColor: '#D175B6',
//                                 color: '#ffffff',
//                                 '& td': {
//                                 }
//                             }
//                         }}>
//                             {rows.map((row, index) => (
//                                 <StyledTableRow key={index}>
//                                     <StyledTableCell>
//                                         <Typography sx={{
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             '& a': {
//                                                 lineHeight: '0',
//                                             },
//                                             '& img': {
//                                                 marginRight: '10px',
//                                             }
//                                         }}>
//                                             <Link to='/event/details'><img src={Show} /></Link>
//                                             {row.eventname}
//                                         </Typography>
//                                     </StyledTableCell>
//                                     <StyledTableCell><Typography>{row.eventstart}</Typography></StyledTableCell>
//                                     <StyledTableCell><Typography>{row.eventsend}</Typography></StyledTableCell>
//                                     <StyledTableCell><Typography>{row.clientname}</Typography></StyledTableCell>
//                                     <StyledTableCell><Typography>{row.contactinfo}</Typography></StyledTableCell>
//                                     <StyledTableCell><Typography>{row.venue}</Typography></StyledTableCell>
//                                 </StyledTableRow>
//                             ))}
//                         </TableBody>

//                     </Table>
//                 </TableContainer>
//                 <Box sx={{
//                     '& td': {
//                         display: 'block',
//                     }
//                 }}>
//                     <TablePagination
//                         sx={{
//                             border: 'none !important',
//                             borderTop: '1px solid #D175B6 !important',
//                             '& *': {
//                                 color: '#ffffff',
//                             },
//                             '& .MuiToolbar-root': {
//                                 justifyContent: 'center',
//                                 '& .MuiTablePagination-spacer': {
//                                     display: 'none',
//                                 }
//                             }
//                         }}
//                         rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
//                         colSpan={6}
//                         count={rows.length}
//                         rowsPerPage={rowsPerPage}
//                         page={page}
//                         SelectProps={{
//                             inputProps: {
//                                 'aria-label': 'rows per page',
//                             },
//                             native: true,
//                         }}
//                         onPageChange={handleChangePage}
//                         onRowsPerPageChange={handleChangeRowsPerPage}
//                         ActionsComponent={TablePaginationActions}
//                     />
//                 </Box>
//             </Box>
//         </>
//     )
// }
// =======
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Icon,
  TableSortLabel,
  Typography,
  Pagination,
  PaginationItem,
  Autocomplete,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import SortArrow from "../../assets/images/sort-arrow.svg";
import TableBody from "@mui/material/TableBody";
import { useTheme } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import dayjs from "dayjs";


// import AssignClientModal from "../../components/AssignClientModal";
// import "./EventRequests.css";
import LoadingOverlay from "../../components/Custom/LoadingOverlay";
import { getZebraRowSx } from "../../components/Table/zebraStripe";


import { apiRequest } from "../../services/apiService";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import { rowsPerPageInit } from "../../utils/constants/paginationConstants";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  // "&:last-child td, &:last-child th": {
  //   border: 0,
  // },
}));

const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
  "&.MuiPaginationItem-root": {
    color: theme.palette.common.white,
  },
  "&.Mui-selected": {
    color: theme.palette.secondary.main,
  },
}));

const Option = ({ option, onClick, props }) => {
  return (
    <>
      <div
        // {...props}
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          padding: "6px 8px",
          boxSizing: "border-box",
          border: `1px solid rgb(209, 117, 182)`,
          borderRadius: `4px`,
          overflow: "visible",
          cursor: "pointer",
        }}
        className={`autocomplete-option`}
        onClick={onClick}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "0.5rem",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
            }}
          >
            <Typography
              style={{
                color: "white",
                margin: "0",
              }}
            >
              {`${option.label} (${option?.venue})`}
            </Typography>
          </div>
        </div>
      </div>
    </>
  );
};

export const LogsOfRequestClient = () => {
  const inputRef = useRef();

  const dispatch = useDispatch();

  const navigate = useNavigate();

  // NOTE: `state.eventRequest.isLoading` is intentionally NOT used to drive this
  // page's spinner. That slice initializes `isLoading: true` and this page never
  // dispatches an eventRequest action to flip it back to false (all those
  // dispatches are commented out below), so reading it here caused a permanent
  // "Logs Of Event" spinner (FIX #1). The only relevant loading flag here is
  // `logsOfEvent.isLoading`, set locally while fetching a specific event's logs.
  const { eventRequests } = useSelector((state) => state.eventRequest);
  const { userRole, userId } = useSelector((state) => state.auth);

  const [rows, setRows] = React.useState([]);
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(rowsPerPageInit);
  const [order, setOrder] = useState("asc");
  const [open, setOpen] = useState(false);
  const [searchStr, setSearchStr] = useState("");
  const [eventInfo, setEventInfo] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [allEvents, setAllEvents] = useState([]);
  const [logsOfEvent, setLogsOfEvent] = useState({
    isLoading: false,
    payload: [],
  });
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  // function refreshNewEventRequest() {
  //   dispatch(
  //     fetchNewEventAction({
  //       payload: {
  //         role: userRole,
  //       },
  //       params: {
  //         page: page,
  //         limit: rowsPerPage,
  //       },
  //     }),
  //   );
  // }

  // React.useEffect(() => {
  //   refreshNewEventRequest();
  // }, []);

  // React.useEffect(() => {
  //   if (!searchStr || searchStr === "") return;
  //   const debounce = setTimeout(() => {
  //     dispatch(
  //       searchNewEventsAction({ page: 1, searchStr, role: userRole }, () => {
  //         setPage(1);
  //       }),
  //     );
  //   }, [300]);

  //   return () => {
  //     clearTimeout(debounce);
  //   };
  // }, [searchStr]);

  // React.useEffect(() => {
  //   setRows(eventRequests);
  // }, [eventRequests]);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    // if (!searchStr || searchStr === "") {
    //   dispatch(
    //     fetchNewEventAction({ role: userRole, page: newPage }, () => {
    //       setPage(newPage);
    //     }),
    //   );
    // } else {
    // setRows(logsOfEvent)
    // }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSortRequest = ({ field }) => {
    const newOrder = order === "asc" ? "desc" : "asc";
    const sortedRows = [...rows].sort((a, b) => {
      const aValue = a[field || "title"];
      const bValue = b[field || "title"];

      if (newOrder === "asc") {
        if (aValue < bValue) {
          return -1;
        }
        if (aValue > bValue) {
          return 1;
        }
        return 0;
      } else {
        if (aValue < bValue) {
          return 1;
        }
        if (aValue > bValue) {
          return -1;
        }
        return 0;
      }
    });
    setRows(sortedRows);
    setOrder(newOrder);
  };

  // const handleSearch = (e) => {
  //   // const searchStr = e.target.value;
  //   // if (!searchStr || searchStr === "") {
  //   //   dispatch(fetchNewEventAction({ role: userRole }));
  //   // } else {
  //   //   dispatch(searchNewEventsAction({ role: userRole, eventName: searchStr }));
  //   // }
  //   setSearchStr(e.target.value);
  // };

  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  // useEffects start...
  useEffect(() => {
    (async () => {
      try {
        const { response, error } = await apiRequest({
          method: "GET",
          url: `getAllEventsOfClient`,
          // FIX #1: scope the request by the logged-in client. The endpoint now
          // also derives the id from the JWT, so this is reinforcement; sending
          // it explicitly avoids the previous 400 when no clientId was passed.
          params: { clientId: userId },
          data: null,
          isToken: true,
        });

        if (error) {}

        // FIX #1: always store an array. Previously `events` could be undefined
        // (e.g. on a 400/empty), which propagated to the Autocomplete `options`
        // prop and triggered MUI warnings / a stuck search dropdown.
        setAllEvents(
          Array.isArray(response?.data?.data?.events)
            ? response?.data?.data?.events
            : [],
        );
      } catch (err) {
        setAllEvents([]);
      }
    })();
  }, [userId]);

  useEffect(() => {
    // FIX #1: guard against `allEvents` being non-array so `filteredEvents`
    // (and therefore the Autocomplete `options`) is never undefined.
    const source = Array.isArray(allEvents) ? allEvents : [];
    setFilteredEvents(
      source.filter((currEvent) => {
        return currEvent?.eventName
          ?.toLowerCase?.()
          ?.includes?.(searchTerm?.toLowerCase?.());
      }),
    );
  }, [searchTerm, allEvents]);

  useEffect(() => {
    (async () => {
      try {
        if (!selectedEvent?._id) {
          return;
        }

        setLogsOfEvent((logsOfEvent) => {
          return {
            ...logsOfEvent,
            isLoading: true,
          };
        });

        const { response, error } = await apiRequest({
          method: "GET",
          url: `getLogsOfSpecificEvent/${selectedEvent?._id}`,
          data: null,
          isToken: true,
        });

        if (response) {
          setLogsOfEvent((logsOfEvent) => {
            return {
              ...logsOfEvent,
              payload: response?.data?.data?.logsData,
            };
          });
          setRows(response?.data?.data?.logsData);
          setPage(1);
        } else if (error) {
          // console.log(error, 'logs.error');
          // dispatch({
          //   type: ALERT_DIALOG,
          //   payload: {
          //     open: true,
          //     title: 'Error!',
          //     message: error?.response?.message
          //   }
          // })
        }
      } catch (err) {} finally {
        setLogsOfEvent((logsOfEvent) => {
          return {
            ...logsOfEvent,
            isLoading: false,
          };
        });
      }
    })();
  }, [selectedEvent]);

  return (
    <>
      <Box
        sx={{
          padding: "20px 40px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          "@media (max-width: 600px)": {
            flexDirection: "column",
            padding: "20px 20px",
          },
        }}
      >
        <Typography
          variant={isSmallScreen ? "h3" : "h1"}
          sx={{
            "@media (max-width: 600px)": {
              marginBottom: "15px",
            },
          }}
        >
          Logs Of Event
        </Typography>
        <Box
          sx={{
            maxWidth: "20rem",
            display: "flex",
            alignItems: "center",
            "& .MuiInputBase-root": {
              border: "1px solid #FFF !important",
              background: "rgba(0, 0, 0, 0.01) !important",
              boxShadow:
                "0px 0px 30px 0px rgba(209, 117, 182, 0.20) !important",
              borderRadius: "8px",
              padding: "0px 24px 5px 16px !important",
              "&:before": {
                content: "none",
              },
              "&:after": {
                content: "none",
              },
              "& svg": {
                color: "#ffffff",
              },
              "& input": {
                color: "#ffffff",
              },
            },
          }}
        >
          <Autocomplete
            options={Array.isArray(filteredEvents) ? filteredEvents : []}
            getOptionLabel={(option) => {
              return `${option.label} (${option?.venue})`;
            }}
            value={
              selectedEvent
                ? {
                    ...selectedEvent,
                    label: selectedEvent?.eventName,
                    value: selectedEvent?._id,
                  }
                : null
            }
            sx={{
              // "& MuiAutocomplete-endAdornment css-p1olib-MuiAutocomplete-endAdornment MuiIconButton-root MuiSvgIcon-root": {
              //   color: 'white'
              // }
              width: "500px",
            }}
            renderInput={(params) => (
              <div
                style={{
                  position: "relative",
                }}
                onClick={(e) => {
                  setIsInputFocused(true);
                }}
              >
                <TextField
                  {...params}
                  ref={inputRef}
                  placeholder={"Type here to search event..."}
                  value={searchTerm}
                  onChange={handleInputChange}
                  variant="filled"
                  focused={isInputFocused}
                  onFocus={(e) => {
                    setIsInputFocused(true);
                  }}
                  onBlur={(e) => {
                    setIsInputFocused(false);
                    setSearchTerm("");
                  }}
                  sx={{
                    border: "none",
                    "& input": {
                      color: "white",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        // borderColor: "black",
                      },
                      "&:hover fieldset": {
                        // borderColor: "black",
                      },
                    },
                    "& .MuiAutocomplete-endAdornment": {
                      "& .MuiButtonBase-root": {
                        "& .MuiSvgIcon-root": {
                          color: getCssVariableHandler({
                            variableName: `--font-rgb`,
                          }),
                        },
                      },
                    },
                  }}
                />

                {isInputFocused ? (
                  <Box
                    sx={{
                      width: `100%`,
                      maxHeight: "500px",
                      overflowY: "scroll",
                      padding: "10px",
                      border: "1px solid rgb(209, 117, 182)",
                      borderRadius: "8px",
                      boxShadow: `7px 7px 20px rgba(209, 117, 182, 0.15), -7px 7px 20px rgba(209, 117, 182, 0.15)`,
                      position: "absolute",
                      top: "100%",
                      right: "0",
                      backgroundColor: "black",
                      zIndex: "4",
                    }}
                    className={"custom-scroll-design"}
                  >
                    {filteredEvents?.map((option) => {
                      return (
                        <React.Fragment key={option?._id}>
                          <Option
                            option={{
                              ...option,
                              label: option?.eventName,
                              value: option?._id,
                            }}
                            onClick={(e) => {
                              e?.stopPropagation();
                              setIsInputFocused(false);
                              setSearchTerm("");
                              setSelectedEvent(option);
                            }}
                          />
                        </React.Fragment>
                      );
                    })}
                  </Box>
                ) : null}
              </div>
            )}
            onChange={(event, option) => {
              setSelectedEvent(option?.value);
            }}
          />

          {/* <FormControl>
            <Select
              value={selectedEvent?.eventName}
              placeholder="Select"
              onChange={(e) => {
                const selectedEventTemp = allEvents?.filter?.(currEvent => {
                  return (currEvent?._id === e.target.value);
                });

                setSelectedEvent(selectedEventTemp);
              }}
              sx={{
                padding: '0',
                width: 'fit-content',
                color: getCssVariableHandler({
                  variableName: "--font-rgb"
                })
              }}
            >
              {allEvents?.map?.((currEvent, currEventIdx) => {
                return (
                  <MenuItem
                    key={currEvent?._id}
                    value={currEvent?._id}
                  >
                    {`${currEvent?.eventName} (${currEvent?.venue})`}
                  </MenuItem>
                )
              })}
            </Select>
          </FormControl> */}
          {/* <Input
            id="input-with-icon-adornment"
            onChange={handleSearch}
            placeholder="Search here"
            startAdornment={
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            }
          /> */}
          {/* <Button
            sx={{
              marginLeft: "10px",
              borderRadius: "4px",
              border: "1px solid #FFF",
              background:
                "linear-gradient(99deg, #F0F 0%, #8F00FF 100.41%) !important",
              boxShadow: "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
              minWidth: "auto",
              padding: "5px !important",
            }}
            onClick={(e) => {
              dispatch(resetCreateEventSlice());
              navigate(`/create-event`);
            }}
          >
            <img src={AddPlus} />
          </Button> */}
        </Box>
      </Box>
      <Box>
        {logsOfEvent?.isLoading ? (
          <LoadingOverlay open={true} />
        ) : (
          <Box>
            <TableContainer
              className="custom-scroll-design"
              sx={{ maxWidth: "100%", minHeight: "calc(100vh - 323px)" }}
            >
              <Table
                // sx={{ minWidth: "1700px" }}
                aria-label="sticky table"
                stickyHeader
              >
                <TableHead>
                  <TableRow
                    sx={{
                      "& th": {
                        backgroundColor: "#D175B6 !important",
                        padding: "2px 15px",
                        fontSize: "20px",
                        color: "#ffffff",
                        borderColor: "#D175B6",
                        "& span": {
                          color: "#ffffff !important",
                        },
                      },
                    }}
                  >
                    <StyledTableCell
                      sx={{
                        width: "20%",
                      }}
                    >
                      <TableSortLabel
                        sx={{
                          padding: "2px 15px 2px 35px",
                        }}
                        active={true}
                        direction={order}
                        onClick={() =>
                          handleSortRequest({
                            field: "eventName",
                          })
                        }
                        IconComponent={(props) => (
                          <IconButton {...props}>
                            <Icon>{<img src={SortArrow} />}</Icon>
                          </IconButton>
                        )}
                      >
                        Log Title
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{
                        width: "60%",
                      }}
                    >
                      <TableSortLabel
                        active={true}
                        direction={order}
                        onClick={() =>
                          handleSortRequest({
                            field: "description",
                          })
                        }
                        IconComponent={(props) => (
                          <IconButton {...props}>
                            <Icon>{<img src={SortArrow} />}</Icon>
                          </IconButton>
                        )}
                      >
                        Description
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{
                        width: "20%",
                      }}
                    >
                      <TableSortLabel
                        active={true}
                        direction={order}
                        onClick={() =>
                          handleSortRequest({
                            field: "activityTime",
                          })
                        }
                        IconComponent={(props) => (
                          <IconButton {...props}>
                            <Icon>{<img src={SortArrow} />}</Icon>
                          </IconButton>
                        )}
                      >
                        Activity Time
                      </TableSortLabel>
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody
                  sx={{
                    "& td": {
                      borderColor: "#D175B6",
                      color: "#ffffff",
                      "& td": {},
                    },
                  }}
                >
                  {rows?.length === 0 ? (
                    <StyledTableRow>
                      <TableCell colSpan={6}>
                        <Typography
                          sx={{
                            textAlign: "center",
                          }}
                        >
                          No logs
                        </Typography>
                      </TableCell>
                    </StyledTableRow>
                  ) : (
                    rows
                      ?.slice((page - 1) * rowsPerPage, page * rowsPerPage)
                      ?.map((row, index) => (
                        <StyledTableRow key={index} sx={getZebraRowSx(index)}>
                          <StyledTableCell>
                            <Typography
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                "& a": {
                                  lineHeight: "0",
                                },
                                "& img": {
                                  marginRight: "10px",
                                },
                              }}
                            >
                              {/* <Link
                            to="/event/new-request/details"
                            state={{
                              id: row?._id,
                              contactId: row?.contactInformationId,
                              coordinatorId: row?.assignedCoordinatorId[0]
                                ? row?.assignedCoordinatorId[0]
                                : null,
                            }}
                          >
                            <img src={Show} />
                          </Link> */}
                              {row?.eventName}
                            </Typography>
                          </StyledTableCell>
                          <StyledTableCell>
                            <Typography>{row?.description}</Typography>
                          </StyledTableCell>
                          <StyledTableCell>
                            <Typography>
                              {dayjs(row?.activityTime).format(
                                "ddd MM/DD/YYYY [at] HH:mm a",
                              )}
                            </Typography>
                            {/* <Typography>We need start time of the session, or position or event</Typography> */}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <Box
              sx={{
                "& td": {
                  display: "block",
                },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "black",
                borderRadius: "0px 0px 15px 15px",
                borderTop: "1px solid #D175B6",
              }}
            >
              <Pagination
                count={Math.ceil(rows?.length / rowsPerPage)}
                page={page}
                onChange={handleChangePage}
                siblingCount={isSmallScreen ? 0 : 1}
                renderItem={(item) => (
                  <StyledPaginationItem
                    slots={{ previous: ArrowBack, next: ArrowForward }}
                    {...item}
                  />
                )}
              />
            </Box>
          </Box>
        )}
      </Box>
      {/* <AssignClientModal
        refreshNewEventRequest={refreshNewEventRequest}
        open={open}
        setOpen={setOpen}
        eventInfo={eventInfo}
        isList={true}
      /> */}
    </>
  );
};